import React from 'react'

import FormattedMessage from 'components/FormattedMessage'

import { CurrentUser } from 'generated/types'

import AddToProject from '../AddToProject'

import './index.less'

const NexusIntegratedDashboardFormSwitcher: React.FC<NexusIntegratedDashboardFormSwitcherProps> = (props) => {
  return (
    <div className="contact-request__form-switcher contact-request__form-switcher--nexus-integrated">
      <h1 className="contact-request__form-switcher__title">
        <FormattedMessage id="contactRequest.formSwitcher.switch.addToProject" />
      </h1>
        <div className="contact-request__form-switcher__item">
          <div className="contact-request__form-switcher__item__content">
            <AddToProject
              projects={props.projects}
              currentUser={props.currentUser}
              onSuccessCallback={props.onSuccessCallback}
              initialData={props.initialData}
              provider={props.provider}
              showCreateNewProjectLink={true}
              />
          </div>
        </div>
    </div>
  )
}

interface NexusIntegratedDashboardFormSwitcherProps extends React.ComponentProps<typeof AddToProject> {
  currentUser: CurrentUser
}

export default NexusIntegratedDashboardFormSwitcher
